import { api } from '@/shared/helpers/axios';
import { ApiRoutes } from '@/constant/api';

export const supportApi = {
	sendTicketToSupport: (payload: FormData) =>
		api.post(ApiRoutes.Support, payload, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}),
};
